import React from 'react';
import { Utilities } from '../utils/Utilities';
import type { YouTubeVideoItem } from '../types/youtube';

interface VideoSearchResultListProps {
    videos: YouTubeVideoItem[];
    loading?: boolean;
    error?: string | null;
}

function VideoSearchResultList({ videos, loading, error }: VideoSearchResultListProps) {
    if (loading) {
        return (
            <div className="video-search-results loading d-flex align-items-center justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading…</span>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="video-search-results error alert alert-danger" role="alert">
                {error}
            </div>
        );
    }

    if (!videos.length) {
        return (
            <div className="video-search-results empty text-muted text-center py-5">
                No videos found. Try changing your filters or search terms.
            </div>
        );
    }

    return (
        <div className="video-search-results">
            <div className="row g-3">
                {videos.map((video) => (
                    <div key={video.videoId} className="col-sm-6 col-md-4 col-lg-3">
                        <div className="video-tile-card card h-100 border-0 shadow-sm position-relative">
                            <a
                                href={`https://www.youtube.com/watch?v=${video.videoId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-decoration-none text-body"
                            >
                                <div className="video-tile-thumb position-relative overflow-hidden rounded-top">
                                    <img
                                        src={video.thumbnail}
                                        alt=""
                                        className="card-img-top"
                                    />
                                    <div className="video-tile-description-overlay">
                                        <p className="small mb-0">
                                            {Utilities.decodeHtmlEntities(video.description || 'No description.')}
                                        </p>
                                    </div>
                                </div>
                                <div className="card-body py-2">
                                    <h6 className="card-title video-tile-title mb-0 text-truncate">
                                        {Utilities.decodeHtmlEntities(video.title)}
                                    </h6>
                                </div>
                            </a>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default VideoSearchResultList;
